<template>
    <div class="default-wrap bill-total">
        <div class="list">
            <div class="item income">
                <div class="title">
                    應收帳款
                    <span class="total">
                        {{receivable.count}} 筆
                    </span>
                </div>
                <div class="content">
                    {{toCurrency(receivable.amount)}}
                </div>
            </div>
            <div class="item">
                <div class="title">
                    已收帳款
                    <span class="total">
                        {{received.count}} 筆
                    </span>
                </div>
                <div class="content blue">
                    {{toCurrency(received.amount)}}
                </div>
            </div>
            <div class="item">
                <div class="title h-align">
                    未收帳款
                    <span class="total">
                        {{unpaid.count}} 筆（未繳 {{unpaid.unpaidCount}}．欠款 {{unpaid.overdueCount}}）
                    </span>
                    <word-tips-hover data="未繳：您已新增帳單但未到繳款時間的狀態。" width="320px" left="-100px"></word-tips-hover>
                </div>
                <div class="content red">
                    {{toCurrency(unpaid.amount)}}
                </div>
            </div>
            <div class="item all">
                <div class="title">
                    繳款率
                </div>
                <div class="content">
                    {{paymentRate}} ％
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import { mapGetters } from 'vuex'
export default {
    methods: {
        isPositive: function (value) {
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }
        }
    },
    computed: {
        paymentRate: function () {
            // return Math.round((this.received.amount/this.receivable.amount)*100)
            return this.receivable.amount?Math.round(this.received.amount/this.receivable.amount*100):0
        },
        ...mapGetters({
            receivable: 'GET_BIZ_BILL_MGT_RECEIVABLE',
            received: 'GET_BIZ_BILL_MGT_RECEIVED',
            unpaid: 'GET_BIZ_BILL_MGT_UNPAID',
            // paymentRate: 'GET_BIZ_BILL_MGT_PAYMENT_RATE',
            // filterResult: 'GET_BIZ_BILL_MGT_FILTER_RESULT'
        })
    },
    components:{
        wordTipsHover
    }
}
</script>

<style lang="scss" scoped>
.bill-total{
    position: relative;
    margin-bottom: 20px;
    .list{
        display: flex;
        align-items: center;
        .item{
            position: relative;
            margin: 0 70px;
            &:after{
                content: '';
                position: absolute;
                width: 1px;
                height: 57px;
                background: #f3f3f3;
                top: 0;
                right: -70px;
            }
            &.all{
                margin-left: 70px;
                margin-right: 0px;
                &:after{
                    display: none;
                }
            }
            .title{
                font-size: 16px;
                margin-bottom: 12px;
                .total{
                    font-size: 12px;
                    padding: 4px 8px;
                    margin-left: 6px;
                    border-radius: 2px;
                    background-color: #f6f6f6;
                }
            }
            .content{
                font-size: 20px;
                font-weight: 500;
                &.blue{
                    color: #3942b5;
                }
                &.red{
                    color: #fc7171;
                }
            }
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/billMgt/billTotal.vue